import { Component, OnInit, Inject, Input } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { IArticle } from '../../core/IArticle';
import { IRalColor } from '../ral-colorpicker/ral-colors';
import { IMetalColor } from '../../core/IMetalColor';
import { IColorSelectedEvent } from '../plate-colorpicker/plate-colorpicker.component';
import { SpecialColorSelection } from '../SpecialColorSelection';

export interface IPlateColorpickerDialogData {
    specialColorArticles: IArticle[];
    isMobileMode?: boolean;
}

export interface IPlateColorpickerDialogResult {
    selectedArticle: IArticle;
    selectedSpecialColor: SpecialColorSelection;
}

@Component({
    selector: 'plate-colorpicker-dialog',
    templateUrl: './plate-colorpicker-dialog.component.html',
    styleUrls: ['./plate-colorpicker-dialog.component.scss']
})
export class PlateColorpickerDialogComponent implements OnInit {
    private specialMetalColorArticle: IArticle;
    private specialRalColorArticle: IArticle;

    public isMobileMode: boolean = false;
    private preventSelection: boolean = true;

    public allowMattGlossySelection: boolean = false;

    public get isMetalColorSelectable(): boolean {
        return this.specialMetalColorArticle !== undefined;
    }

    public get isRalColorSelectable(): boolean {
        return this.specialRalColorArticle !== undefined;
    }

    constructor(public dialogRef: MatDialogRef<PlateColorpickerDialogComponent>,
                @Inject(MAT_DIALOG_DATA) public dialogData: IPlateColorpickerDialogData
    ) {
        this.isMobileMode = dialogData.isMobileMode;

        dialogData.specialColorArticles.forEach((article: IArticle) => {
            const isSpecialMetalColorArticle = (article.attributes["special-type"][0] === 0);
            const isSpecialRalColorArticle = (article.attributes["special-type"][0] === 1);

            if (isSpecialMetalColorArticle)
                this.specialMetalColorArticle = article;
            if (isSpecialRalColorArticle)
                this.specialRalColorArticle = article;
        });

        // for some reason, clicks meant to open a dialog do sometimes go through to the dialog while it is animating
        // thus closing the dialog before it has even opened
        setTimeout(() => this.preventSelection = false, 500);
    }

    public ngOnInit(): void {}

    public colorSelected(event: IColorSelectedEvent) {
        if (this.preventSelection)
            return;

        this.closeDialog({
            selectedArticle: event.color.isRalColor ? this.specialRalColorArticle : this.specialMetalColorArticle,
            selectedSpecialColor: event.color
        });
    }

    public closeDialog(result: IPlateColorpickerDialogResult) {
        this.dialogRef.close(result);
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/plate-colorpicker-dialog/plate-colorpicker-dialog.component.ts